import { useState, useEffect } from 'react';
import {
  useOutletContext,
  useLocation,
  useParams,
  useNavigate,
} from 'react-router-dom';
import { useGlobalStore } from 'store/globalStore';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import './Videos.css';
import Modal from '../../components/common/Modal';
import Transcoder from '../../components/modals/Transcoder';
import MenuSteps from './MenuSteps';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import StepFive from './StepFive';
import StepSix from './StepSix';
import StepSeven from './StepSeven';
import '@aws-amplify/ui-react/styles.css';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ArrowBackIosNewOutlined from '@mui/icons-material/ArrowBackIosNewOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { createVideo, getVideoById, getMediaMainById, getVersionsById } from './Resources';
import ModalTitle from '../../components/modals/ModalTitle';
import {
  Button,
  Grid,
  Box,
  Typography,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Fade,
  CircularProgress,
} from '@mui/material';
import languages from '../../utils/languages';
//import USER_PROFILE from '../../utils/userProfile';
import { convertDateUtc } from '../../utils/convertDateUtc';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import {
  CRUD_STATES,
  INITIAL_RELATED_COLLECTION_LIST,
  RELATED_COLLECTION_LIST,
  RELATED_VIDEO_COLLECTION_LIST,
  VIDEO_COLLECTION_SUGGESTION,
} from 'constants/app';
import _ from 'lodash';
import {
  tableSelectedListUtility,
  useTableSelectedList,
} from 'hooks/useTableSelectedList';
import { adminAPI, videoAPI } from 'services/admin';
import { useNotification } from 'hooks/useNotification';

const steps = [
  {
    id: 1,
    label: '1. Adicionar vídeos',
    description: `Vídeo principal, áudios e legendas`,
  },
  {
    id: 2,
    label: '2. Vídeos complementares (opcional)',
    description: 'Trailer e video linguagem de sinais',
  },
  {
    id: 3,
    label: '3. Informações do vídeo',
    description: `Descrições, associações e limites de Players`,
  },
  {
    id: 4,
    label: '4. Elementos associados',
    description: `Associar a coleções, sugeridos/relacionados`,
  },
  {
    id: 5,
    label: '5. Contratos dos conteúdos',
    description: `Observações gerais de uso interno`,
  },
  {
    id: 6,
    label: '6. Resumo',
    description: `Resumo da publicação`,
  },
  {
    id: 7,
    label: '7. Publicação',
    description: ``,
  },
];

function VideosSteps(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    setEditItem,
    isExistVideo,
    setCancelUpload,
    uploadIsLoading,
    setRefreshData,
    // setUploadIsLoading,
  } = useGlobalStore();
  const [auth, setAuth] = useOutletContext();
  const {
    setOpenTranscoder,
    activeStep,
    setActiveStep,
    videoMainUploadProgress,
    trailerUploadProgress,
    videoAcessibilityUploadProgress,
    legendaTrailerUploadProgress,
    legendaAccessibilityUploadProgress,
    videoMainUploadComplete,
    //mainUploaded,
    setMainUploaded,
    //trailerUploaded,
    setTrailerUploaded,
    //accessibilityUploaded,
    setAccessibilityUploaded,
    setVideoMainUploadProgress,
    setAudioMainUploadProgress,
    setSubtitleMainUploadProgress,
    setTrailerUploadProgress,
    setVideoTrailerUploadProgress,
    setVideoAcessibilityUploadProgress,
    setLegendaAccessibilityUploadProgress,
    setVideoResponse,
    videoResponse,
    isLoading,
    setIsLoading,
  } = useAppProviderStore();

  const { setNotify, closeAllNotifications } = useNotification();

  const relatedCollectionList = useTableSelectedList(RELATED_COLLECTION_LIST);
  const initialRelatedCollectionList = useTableSelectedList(
    INITIAL_RELATED_COLLECTION_LIST
  );

  const relatedVideoCollectionList = useTableSelectedList(
    RELATED_VIDEO_COLLECTION_LIST
  );
  const videoOrCollectionSuggestion = useTableSelectedList(
    VIDEO_COLLECTION_SUGGESTION
  );

  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const params = useParams();
  const [transcoderAproval, setTranscoderAproval] = useState({
    main: false,
    trailer: false,
    accessibility: false,
  });
  // const [watchMainTranscoder, setWatchMainTranscoder] = useState('');
  // const [watchTrailerTranscoder, setWatchTrailerTranscoder] = useState('');
  // const [watchAccessibilityTranscoder, setWatchAccessibilityTranscoder] =
  //   useState('');
  const [text, setText] = useState('Ver Mais');
  const [expanded, setExpanded] = useState(false);
  const [videoProps, setVideoProps] = useState({});
  const [viewFields, setViewFields] = useState(false);
  const [wordsList, setWordsList] = useState([]);
  const [keyWordsList, setKeyWordsList] = useState([]);
  const { showConfirmationButton } = useState(true);

  // hooks do passo 1
  const [videoFiles, setVideoFiles] = useState();
  const [subtitleFiles, setSubtitleFiles] = useState([]);
  const [legendaIdioma, setLegendaIdioma] = useState([]);
  const [canAddSubtitle, setCanAddSubtitle] = useState(false);
  const [canAddAudio, setCanAddAudio] = useState(false);
  const [audioFiles, setAudioFiles] = useState([]);
  const [audioIdioma, setAudioIdioma] = useState([]);
  const [idiomaVideo, setIdiomaVideo] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  //const [userProfile, setUserProfile] = useState();
  const [comments, setComments] = useState('');
  const [contracts, setContracts] = useState([]);
  const [userProps] = useState({});
  const [formValidation, setFormValidation] = useState(null);
  const [selectedOption, setSelectedOption] = useState({});
  const [openTitleModal, setOpenTitleModal] = useState(false);
  const [hasPublishedPreviousVersion, setHasPublishedPreviousVersion] = useState(false);
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    register,
    reset,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      searchable: true,
    },
  });
  const visibility = watch('visibility');

  const handler = () => {
    // window.removeEventListener("beforeunload", handlerOnBeforeUnload, {
    //   capture: true,
    // });
    setConfirmDialogAction({
      isOpen: true,
      title: <div className="modalTitleText">Deseja sair da página?</div>,
      subTitle: (
        <div className="modalBodyText">
          Existem uploads em andamento, ao sair, o progresso será perdido.
          Deseja continuar?
        </div>
      ),
      children: (
        <div className="modalRemoveItem">
          <WarningAmberIcon color="secondary" fontSize="12px" />
        </div>
      ),
      confirmTextButton: 'Confirmar',
      color: 'error',
      onConfirm: async () => {
        setIsLoading(true);
        setActiveStep(1);
        setMainUploaded(false);
        setTrailerUploaded(false);
        setAccessibilityUploaded(false);
        setVideoMainUploadProgress(null);
        setAudioMainUploadProgress(null);
        setSubtitleMainUploadProgress(null);
        setTrailerUploadProgress(null);
        setVideoTrailerUploadProgress(null);
        setVideoAcessibilityUploadProgress(null);
        setLegendaAccessibilityUploadProgress(null);
        let resp = await getVideoStatus();
        if (resp?.status === 'DRAFT' && !viewFields) {
          if (uploadVerification()) {
            setCancelUpload(true);
          }
          await deleteVideoId(true);
        }
        let open = 'isOpen';
        setConfirmDialogAction(prevSelectedOptions => ({
          ...prevSelectedOptions,
          [open]: false,
        }));

        resetStateHook();
        navigate('/videos');
        // window.location.reload(true);
        setIsLoading(false);
      },
      showConfirmationButton: true,
      closeTextButton: 'Cancelar',
    });
  };

  const isOverEighteen = () => {
    if (visibility === 'EVERYONE') {
      return !!['18', 'A18'].includes(videoProps?.ageRating);
    } else {
      return false;
    }
  };

  useEffect(() => {
    // reset step on exit
    return () => {
      setActiveStep(1);
      closeAllNotifications();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO review effect of removing
  // useEffect(() => {
  //   if (notify) {
  //     setUploadIsLoading(false);
  //   }
  // }, [notify, setUploadIsLoading]);

  async function mountEditAndView() {
    setIsLoading(true);
    const path = `/${params?.id}/versions`;
    const response = await getVideoById(
      `${path}/${params?.version}`,
      auth,
      setAuth,
      () => {}, // remove setIsLoading
      setNotify
    );
    let mediaId = response?.mediaId;

    const versions = await getVersionsById(
      path,
      auth,
      setAuth,
      setIsLoading,
      setNotify
    );
    let hasPrevPublished = false;

    if (versions?.itemsCount > 1) {
      const currentVersion = response?.version || Number(params?.version) || 1;
      const versionList = versions?.versionList || [];

      hasPrevPublished = versionList.some(v => {
        return v.version < currentVersion && v.status === 'PUBLISHED';
      });

      setHasPublishedPreviousVersion(hasPrevPublished);
    }
    if (mediaId) {
      await getMediaMainById(
        auth,
        mediaId,
        setValue,
        setVideoFiles,
        setIdiomaVideo,
        setLegendaIdioma,
        setCanAddAudio,
        setCanAddSubtitle,
        setAudioFiles,
        setAudioIdioma,
        setSubtitleFiles,
        setAuth,
        setNotify,
        setIsLoading
      );
    }

    let nextContentSuggestion = null;
    if (
      response?.nextContentSuggestion?.id ||
      response?.nextContentSuggestion?.contentId
    ) {
      const nextSuggestionToTableValue = {
        ...response?.nextContentSuggestion,
        id:
          response?.nextContentSuggestion?.contentId ||
          response?.nextContentSuggestion?.id,
      };

      videoOrCollectionSuggestion.setSelectedItems([
        nextSuggestionToTableValue,
      ]);

      nextContentSuggestion = {
        contentId:
          response?.nextContentSuggestion?.contentId ||
          response?.nextContentSuggestion?.id ||
          null,
        contentType:
          response?.nextContentSuggestion?.contentType ||
          response?.nextContentSuggestion?.type ||
          null,
      };
    }

    reset({
      ageRating: response?.ageRating,
      allowedCountries: response?.allowedCountries || [],
      deniedCountries: response?.deniedCountries || [],
      launchingCountry: response?.launchingCountry || [],
      launchYear: response?.launchYear,
      channels: response?.channels
        ? response?.channels.map(channel => ({
            value: channel.channelId,
            label: channel.name,
            channelId: channel.channelId,
          }))
        : [],
      collections: response?.collections || [],
      comments: response?.comments || '',
      createdAt: response?.createdAt,
      createdBy: response?.createdBy,
      hasExpiresIn: !!response.expiresIn,
      expiresIn: response.expiresIn,
      hasPublishIn: !!response.publishIn,
      publishIn: response.publishIn,
      deleted: response?.deleted,
      fullDescription: response?.fullDescription || '',
      id: response?.id,
      nextContentSuggestion: nextContentSuggestion,
      relatedContents: response?.relatedContents,
      languageId: response?.languageId,
      keywords: response.keywords || [],
      mediaId: response?.mediaId,
      mediaWithAcessibilityId:
        response?.mediaWithAcessibilityId || response?.videoWithAccessibility,
      nextSuggestionTimeSeconds: response?.nextSuggestionTimeSeconds
        ? response?.nextSuggestionTimeSeconds
        : 0,
      personalitiesCredits: response?.personalitiesCredits
        ? response?.personalitiesCredits.map(person => ({
            value: person.personalityId,
            label: person.name,
            personalityId: person.personalityId,
          }))
        : [],
      personalities: response?.personalities
        ? response?.personalities.map(person => ({
            value: person.personalityId,
            label: person.name,
            personalityId: person.personalityId,
          }))
        : [],
      publishedAt: response?.publishedAt,
      shortDescription: response?.shortDescription || '',
      status: response?.status,
      technicalSheet: response?.technicalSheet,
      title: response?.title || '',
      trailerId: response?.trailerId || response?.trailer?.mediaId,
      type: response?.type,
      units: response?.units
        ? response?.units.map(unit => ({
            value: unit.unitId,
            label: unit.name,
          }))
        : [],
      updatedAt: response?.updatedAt,
      updatedBy: response?.updatedBy,
      version: response?.version,
      visibility: response?.visibility,
      video_language: { value: response.languageId },
      viewsLimit: response?.viewsLimit || 0,
      thumbnailUrl: response?.thumbnailUrl,
      thumbnails: response?.thumbnails,
      targetAudiences:
        response?.targetAudiences?.map(targetAudience => targetAudience.code) ||
        [],
      searchable:
        response?.searchable !== undefined ? response?.searchable : true,
    });
    setVideoResponse(response);
    setVideoProps(response);
    setIsLoading(false);
  }

  useEffect(() => {
    if (params.action === 'CREATE') {
      navigate(`/upload-video/${params?.id}/${params.version}`, {
        state: { action: CRUD_STATES.CREATE, replace: true },
      });
    }

    if (activeStep === 1 || activeStep === 2) {
      let crudAction;

      if (params.action === 'CREATE') {
        crudAction = 'CREATE';
      } else {
        crudAction = location?.state?.action;
      }
      //setUserProfile(auth.getIdToken().payload['custom:user_profile']);
      if (
        [CRUD_STATES.EDIT, CRUD_STATES.CREATE, CRUD_STATES.VIEW].includes(
          crudAction
        )
      ) {
        crudAction === CRUD_STATES.VIEW && setViewFields(true);

        resetStateHook();
        mountEditAndView();
      }
    }

    setEditItem(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  async function updateVideo(values) {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      let path = `/${values.id}/versions/${getValues('version')}`;
      const session = auth;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
        body: values,
      };

      return videoAPI
        .put(path, data)
        .then(resp => {
          resolve(resp);
          setIsLoading(false);
          if (activeStep === 4) {
            return new Promise((resolve, reject) => {
              let path = `/${values.id}/versions/${getValues(
                'version'
              )}/related-contents`;
              const session = auth;

              const data = {
                createdBy: {
                  userId: session.getIdToken().payload.sub,
                  name: session.getIdToken().payload.username,
                },
                body: {
                  relatedContents:
                    tableSelectedListUtility.mapTableDataToRemote(
                      relatedVideoCollectionList.selectedItems,
                      ['contentId', 'contentType', 'createSortNumber']
                    ),
                },
              };

              return videoAPI
                .put(path, data)
                .then(resp => {
                  setIsLoading(false);
                  resolve(resp);
                })
                .catch(error => {
                  reject(error.message);
                  setIsLoading(false);

                  const errorJson = error.request.response;
                  const parseJson = JSON.parse(errorJson);

                  setNotify({
                    isOpen: true,
                    message: parseJson.message,
                    type: 'error',
                    title: `Passo ${activeStep}: Erro ao atualizar vídeos ou coleções associadas.`,
                  });
                  console.log(error);
                });
            });
          }
        })
        .catch(error => {
          reject(error.message);
          setIsLoading(false);
          const errorJson = error.request.response;
          const parseJson = JSON.parse(errorJson);
          const messageDetails = parseJson?.metadata?.issues?.map(
            issue => issue.message
          );
          setNotify({
            isOpen: true,
            message: !parseJson?.metadata?.issues
              ? parseJson.message
              : messageDetails.join(', '),
            type: 'error',
            title: `Passo ${activeStep}: Erro ao atualizar dados.`,
          });
        });
    });
  }

  const handleOpen = async action => {
    setOpenTitleModal(true);
  };

  async function publishVideo() {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      let id = getValues('id');
      let version = getValues('version');

      const path = `/${id}/versions/${version}/status/published`;
      const session = auth;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      return videoAPI
        .patch(path, data)
        .then(resp => {
          setIsLoading(false);
          setViewFields(true);
          resolve(resp);
        })
        .catch(error => {
          const errorJson = error.request.response;
          const parseJson = JSON.parse(errorJson);
          const messageDetails = parseJson?.metadata?.issues?.map(
            issue => issue?.message
          );
          setNotify({
            isOpen: true,
            message: !parseJson?.metadata?.issues
              ? parseJson.message
              : messageDetails.join(', '),
            type: 'error',
            title: `Erro ao publicar conteúdo.`,
          });
          setIsLoading(false);
        });
    });
  }

  const handleNext = async () => {
    if (isExistVideo !== undefined) {
      if (location?.state?.action === CRUD_STATES.VIEW || viewFields) {
        if (activeStep < 7 && !isLoading) {
          setActiveStep(prevActiveStep => {
            return prevActiveStep + 1;
          });
        }
      } else {
        await onSubmit();

        setActiveStep(prevActiveStep => {
          return prevActiveStep + 1;
        });
      }
    } else {
      setNotify({
        isOpen: true,
        message:
          'Mídia não identificada, para avançar insira a mídia primeiro!',
        type: 'info',
        title: 'Atenção.',
      });
    }
  };

  const handleExit = async () => {
    if (uploadVerification()) {
      handler();
    } else {
      resetStateHook();
      setRefreshData();
      navigate('/videos');
      // window.location.reload(true);
    }
    // if(viewFields){
    //   navigate("/videos");
    // }else{
    //   handler();
    // }
  };

  const handleSaveAndExit = async () => {
    if (uploadVerification()) {
      setNotify({
        isOpen: true,
        message:
          'Existem uploads em andamento, por favor, aguarde a finalização para poder salvar e sair.',
        type: 'info',
        title: 'Por favor, aguarde!',
      });
      return;
    }
    if (
      location?.state?.action === CRUD_STATES.EDIT ||
      location?.state?.action === CRUD_STATES.CREATE
    ) {
      const response = await onSubmit();
      if (response) {
        setTimeout(() => {
          resetStateHook();
          navigate('/videos');
          // window.location.reload(true);
        }, 1000);
      }
    }

    // if (
    //   location?.state?.action === CRUD_STATES.EDIT ||
    //   location?.state?.action === CRUD_STATES.CREATE
    // ) {
    //   if (activeStep === 1 || activeStep === 2) {
    //     setOpenTranscoder(true);
    //     return;
    //   }
    // }
  };

  const handleNextWithoutSave = async () => {
    if (activeStep < 7 && !isLoading) {
      setActiveStep(prevActiveStep => {
        return prevActiveStep + 1;
      });
    }
  };

  const handlePublish = async () => {
    if (uploadVerification()) {
      setNotify({
        isOpen: true,
        message:
          'Existem uploads em andamento, por favor, aguarde a finalização para poder publicar o conteúdo.',
        type: 'info',
        title: 'Por favor, aguarde!',
      });
    } else {
      if (
        activeStep === 7 &&
        (location?.state?.action === CRUD_STATES.EDIT ||
          location?.state?.action === CRUD_STATES.CREATE)
      ) {
        setOpenTranscoder(true);
        return;
      }
    }
  };

  const handleConfirmPublish = async () => {
    let formValidation = await onSubmitFormValidation();

    if (formValidation === true) {
      await publishVideo();
      // if (activeStep < 7 && !isLoading && !notify.isOpen) {
      //   setActiveStep(prevActiveStep => {
      //     return prevActiveStep + 1;
      //   });
      // }
    }
  };

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(prevActiveStep => {
        return prevActiveStep - 1;
      });
    }
  };

  const handleAccordionChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      setText('Ver Menos');
    } else {
      setText('Ver Mais');
    }
  };

  async function deleteVideoId(removedByUser) {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      let id = getValues('id');
      let version = getValues('version');

      if (id || removedByUser) {
        const path = `/${id}/versions/${version}`;

        return videoAPI
          .del(path)
          .then(resp => {
            setIsLoading(false);
            resetStateHook();
            resolve(resp);
          })
          .catch((error, resp) => {
            setIsLoading(false);
            reject(error);
            console.log(error);
            const errorJson = error.request.response;
            const parseJson = JSON.parse(errorJson);
            setNotify({
              isOpen: true,
              message: parseJson.message,
              type: 'error',
              title: `Passo ${activeStep}: Erro ao excluir vídeo.`,
            });
          });
      }
    });
  }

  async function getVideoStatus() {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      let id = getValues('id');
      let version = getValues('version')
        ? getValues('version')
        : videoProps?.version;
      if (id) {
        const path = `/${id}/versions/${version || 1}`;

        const session = auth;

        const data = {
          createdBy: {
            userId: session.getIdToken().payload.sub,
            name: session.getIdToken().payload.username,
          },
        };

        return videoAPI
          .get(path, data)
          .then(resp => {
            setIsLoading(false);
            resolve(resp);
          })
          .catch(error => {
            setIsLoading(false);
            console.log(error);
            const errorJson = error.request.response;
            const parseJson = JSON.parse(errorJson);
            setNotify({
              isOpen: true,
              message: parseJson.message,
              type: 'error',
              title: `Passo ${activeStep}: Erro ao buscar vídeos.`,
            });

            navigate('/videos');
            // window.location.reload(true);
          });
      } else {
        return;
      }
    });
  }

  const resetStateHook = () => {
    setVideoFiles([]);
    setSubtitleFiles([]);
    setLegendaIdioma([]);
    setCanAddSubtitle(false);
    setCanAddAudio(false);
    setAudioFiles([]);
    setAudioIdioma([]);
    setValue('audio_idioma', null);
    setValue('subtitle', null);
    setValue('title', '');
    setValue('mediaId');
    setIsEdit(false);
    setComments('');
    setContracts([]);
    setWordsList([]);
    setKeyWordsList([]);

    relatedCollectionList.reset();
    initialRelatedCollectionList.reset();
    relatedVideoCollectionList.reset();
    videoOrCollectionSuggestion.reset();

    reset({
      ageRating: '',
      allowedCountries: [],
      deniedCountries: [],
      channels: [],
      collections: [],
      comments: '',
      createdAt: '',
      createdBy: '',
      deleted: false,
      fullDescription: '',
      id: '',
      nextContentSuggestion: null,
      languageId: '',
      mediaId: '',
      mediaWithAcessibilityId: '',
      personalitiesCredits: [],
      personalities: [],
      publishedAt: '',
      relatedContents: [],
      shortDescription: '',
      status: '',
      technicalSheet: '',
      title: '',
      trailerId: '',
      type: '',
      units: [],
      updatedAt: '',
      updatedBy: '',
      version: 0,
      visibility: '',
      video_language: '',
      viewsLimit: 0,
      thumbnailUrl: '',
      thumbnails: [],
      targetAudiences: null,
      launchYear: '',
      dateValue: '',
      limitViews: 0,
      searchable: true,
    });
    reset();
  };

  const handleClose = async () => {
    if (!uploadIsLoading) {
      if (activeStep === 7) {
        setConfirmDialogAction({
          isOpen: false,
        });
        navigate('/videos');
        return;
      }
      if (location?.state?.action === CRUD_STATES.VIEW) {
        resetStateHook();
        setConfirmDialogAction({
          isOpen: false,
        });
        navigate('/videos');
        return;
      }
      if (location?.state?.action === CRUD_STATES.CREATE) {
        let id = getValues('id');
        if (id) {
          setConfirmDialogAction({
            isOpen: true,
            title: (
              <div className="modalTitleText">Deseja remover o cadastro?</div>
            ),
            subTitle: (
              <div className="modalBodyText">
                Essa ação exclui o cadastro permanentemente, deseja continuar?
              </div>
            ),
            children: (
              <div className="modalRemoveItem">
                <DeleteOutlineOutlinedIcon color="error" fontSize="12px" />
              </div>
            ),
            confirmTextButton: 'Sim, excluir',
            color: 'error',
            onConfirm: async () => {
              if (location?.state?.action === CRUD_STATES.CREATE) {
                setConfirmDialogAction({
                  isOpen: false,
                });
                await deleteVideoId(true);
                if (uploadVerification()) {
                  setCancelUpload(true);
                }
                resetStateHook();
                navigate('/videos');
              }
            },
            showConfirmationButton: { showConfirmationButton },
            confirmTextCloseButton: 'Não, salvar e sair.',
            showCancelWithAction: true,
            onConfirmAndClose: async () => {
              if (location?.state?.action === CRUD_STATES.CREATE) {
                if (uploadVerification()) {
                  setConfirmDialogAction({
                    isOpen: false,
                  });
                  setNotify({
                    isOpen: true,
                    message:
                      'Existem uploads em andamento, por favor, aguarde a finalização para poder sair.',
                    type: 'info',
                    title: 'Por favor, aguarde!',
                  });
                  return;
                } else {
                  await onSubmit();
                  setConfirmDialogAction({
                    isOpen: false,
                  });
                  navigate('/videos');
                }
              }
            },
            closeTextButton: 'Não',
          });
        } else {
          navigate('/videos');
        }
      }
      if (location?.state?.action === CRUD_STATES.EDIT) {
        if (uploadVerification()) {
          setConfirmDialogAction({
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message:
              'Existem uploads em andamento, por favor, aguarde a finalização para poder sair.',
            type: 'info',
            title: 'Por favor, aguarde!',
          });
          return;
        } else {
          navigate('/videos');
        }
      }
    } else {
      setNotify({
        isOpen: true,
        message:
          'Existem uploads em andamento, por favor, aguarde a finalização para poder sair.',
        type: 'info',
        title: 'Por favor, aguarde!',
      });
    }
  };

  const renderTitle = (step, index) => {
    if (activeStep === step.id) {
      return (
        <div className="unit_title_page2" key={index}>
          {step.label}
        </div>
      );
    }
  };

  const onSubmit = async () => {
    setIsLoading(true);
    const formValues = getValues();
    let launchingCountry = [];
    if (formValues?.launchingCountry?.length) {
      for (let country of formValues.launchingCountry) {
        launchingCountry.push({ countryId: country.countryId });
      }
    }

    let units = [];
    if (formValues?.units) {
      for (let unit of formValues.units) {
        units.push({ unitId: unit.value || unit.unitId });
      }
    }

    let personalities = [];
    if (formValues?.personalities) {
      for (let person of formValues.personalities) {
        personalities.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let personalitiesCredits = [];
    if (formValues?.personalitiesCredits) {
      for (let person of formValues.personalitiesCredits) {
        personalitiesCredits.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let channels = [];
    if (formValues?.channels?.length) {
      for (let channel of formValues.channels) {
        channels.push({ channelId: channel?.channelId || channel?.value });
      }
    }

    let allowedCountries = [];
    let deniedCountries = [];
    if (formValues?.allowedCountries?.length) {
      for (let country of formValues.allowedCountries) {
        allowedCountries.push({ countryId: country.countryId });
      }
    }

    if (formValues?.deniedCountries?.length) {
      for (let country of formValues.deniedCountries) {
        deniedCountries.push({ countryId: country.countryId });
      }
    }

    // update collection
    const relatedCollectionsUpdateAction =
      tableSelectedListUtility.getCurrentRelatedCollectionUpdate({
        currentRelatedCollection: relatedCollectionList?.selectedItems,
        initialtRelatedCollection: initialRelatedCollectionList?.selectedItems,
      });

    relatedCollectionsUpdateAction?.toUpdateIds?.length &&
      (await adminAPI.put(
        `/admin/videos/${formValues?.id}/versions/${formValues?.version}/series`,
        {
          body: {
            collections: relatedCollectionsUpdateAction.toUpdateIds.map(id => ({
              collectionId: id,
            })),
          },
        }
      ));

    // delete collection
    relatedCollectionsUpdateAction?.toDeleteIds?.length &&
      (await adminAPI.del(
        `/admin/contents/${formValues?.id}/versions/${formValues?.version}/series`,
        {
          body: {
            collectionIdList: relatedCollectionsUpdateAction.toDeleteIds,
          },
        }
      ));

    // Update to currentItems
    initialRelatedCollectionList.setSelectedItems(
      relatedCollectionList.selectedItems
    );

    //proximo passo
    let valuesToUpdate = {
      id: formValues?.id,
      searchable:
        formValues?.searchable !== undefined ? formValues?.searchable : true,
      version: formValues?.version,
      type: 'VIDEO',
      mediaId: formValues?.mediaId || '',
      // collections: tempCollections || [],
      //faltou esse campo no passo 2
      mediaWithAcessibilityId: formValues?.mediaWithAcessibilityId || null,
      comments: formValues?.comments || '', //string
      //faltou esse campo no passo 2
      trailerId: formValues?.trailerId || null,
      personalitiesCredits: personalitiesCredits,
      personalities: personalities,
      expiresIn: convertDateUtc(formValues?.expiresIn) || '', //  "campo não pode ser nulo"
      publishIn: convertDateUtc(formValues?.publishIn) || '', //  "campo não pode ser nulo"
      viewsLimit: parseInt(formValues?.viewsLimit) || 0, //  "campo não pode ser nulo"
      nextSuggestionTimeSeconds: formValues?.nextSuggestionTimeSeconds
        ? formValues?.nextSuggestionTimeSeconds
        : 60,
      title: formValues?.title,
      ageRating: formValues?.ageRating,
      allowedCountries: allowedCountries,
      deniedCountries: deniedCountries,
      shortDescription: formValues?.shortDescription,
      fullDescription: formValues?.fullDescription,
      units: units,
      channels: channels,
      launchYear: formValues?.launchYear,
      thumbnails: _.cloneDeep(formValues?.thumbnails || []).map(obj =>
        _.omit(obj, ['tempURL'])
      ),
      technicalSheet: formValues?.technicalSheet || '',
      keywords: formValues?.keywords || [],
      nextContentSuggestion: videoOrCollectionSuggestion.selectedItems?.[0]
        ? {
            contentId: videoOrCollectionSuggestion.selectedItems?.[0]?.id,
            contentType:
              videoOrCollectionSuggestion.selectedItems?.[0]?.type ||
              videoOrCollectionSuggestion.selectedItems?.[0]?.contentType,
          }
        : null,
      launchingCountry: launchingCountry,
      relatedFiles: formValues?.relatedFiles || [],
      visibility: formValues?.visibility,
      targetAudiences:
        formValues.targetAudiences?.map(targetAudience => ({
          code: targetAudience,
        })) || [],
    };

    if (!formValues?.publishIn) {
      delete valuesToUpdate.publishIn;
    }

    if (!formValues?.expiresIn) {
      delete valuesToUpdate.expiresIn;
    }

    if (!formValues?.trailerId) {
      delete valuesToUpdate.trailerId;
    }

    if (!formValues?.thumbnails || formValues.thumbnails.length === 0) {
      delete valuesToUpdate.thumbnails;
    }

    if (!videoOrCollectionSuggestion?.selectedItems?.[0]) {
      delete valuesToUpdate.nextSuggestionTimeSeconds;
    }

    if (!formValues?.mediaWithAcessibilityId) {
      delete valuesToUpdate.mediaWithAcessibilityId;
    }

    if (activeStep === 3) {
      onSubmitFormValidation();
    }

    try {
      let response = await updateVideo(valuesToUpdate);
      return !(response === 'Network Error');
    } catch (error) {
      return false;
    }
  };

  const verifyUpload = () => {
    if (
      videoMainUploadProgress &&
      ((videoMainUploadProgress?.percent > 0 &&
        videoMainUploadProgress?.percent < 100) ||
        !videoMainUploadComplete)
    ) {
      return true;
    } else if (
      trailerUploadProgress?.percent > 0 &&
      trailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      videoAcessibilityUploadProgress?.percent > 0 &&
      videoAcessibilityUploadProgress?.percent < 100
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onSubmitFormValidation = async () => {
    setIsLoading(true);
    const formValues = getValues();
    let launchingCountry = [];
    if (formValues?.launchingCountry?.length) {
      for (let country of formValues.launchingCountry) {
        launchingCountry.push({ countryId: country.countryId });
      }
    }

    let units = [];
    if (formValues?.units) {
      for (let unit of formValues.units) {
        units.push({ unitId: unit.value || unit.unitId });
      }
    }

    let personalities = [];
    if (formValues?.personalities) {
      for (let person of formValues.personalities) {
        personalities.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let personalitiesCredits = [];
    if (formValues?.personalitiesCredits) {
      for (let person of formValues.personalitiesCredits) {
        personalitiesCredits.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let channels = [];
    if (formValues?.channels?.length) {
      for (let channel of formValues.channels) {
        channels.push({ channelId: channel?.channelId || channel?.value });
      }
    }

    let allowedCountries = [];
    let deniedCountries = [];
    if (formValues?.allowedCountries?.length) {
      for (let country of formValues.allowedCountries) {
        allowedCountries.push({ countryId: country.countryId });
      }
    }

    if (formValues?.deniedCountries?.length) {
      for (let country of formValues.deniedCountries) {
        deniedCountries.push({ countryId: country.countryId });
      }
    }

    //publicar
    let valuesToUpdate = {
      id: formValues?.id,
      searchable:
        formValues?.searchable !== undefined ? formValues?.searchable : true,
      version: formValues?.version,
      type: 'VIDEO',
      mediaId: formValues?.mediaId,
      // collections: tempCollections || [],
      //faltou esse campo no passo 2
      mediaWithAcessibilityId: formValues?.mediaWithAcessibilityId || '',
      comments: formValues?.comments || '', //string
      //faltou esse campo no passo 2
      trailerId: formValues?.trailerId || '',
      personalitiesCredits: personalitiesCredits,
      personalities: personalities,
      expiresIn: convertDateUtc(formValues?.expiresIn) || '', //  "campo não pode ser nulo"
      publishIn: convertDateUtc(formValues?.publishIn) || '',
      viewsLimit: parseInt(formValues?.viewsLimit) || 0, //  "campo não pode ser nulo"
      nextSuggestionTimeSeconds: formValues?.nextSuggestionTimeSeconds
        ? formValues?.nextSuggestionTimeSeconds
        : 60,
      title: formValues?.title,
      ageRating: formValues?.ageRating,
      allowedCountries: allowedCountries,
      deniedCountries: deniedCountries,
      shortDescription: formValues?.shortDescription,
      fullDescription: formValues?.fullDescription,
      units: units,
      channels: channels,
      launchYear: formValues?.launchYear,
      thumbnails: _.cloneDeep(formValues?.thumbnails || []).map(obj =>
        _.omit(obj, ['tempURL'])
      ),
      technicalSheet: formValues?.technicalSheet, // string
      keywords: formValues?.keywords || [],
      nextContentSuggestion: videoOrCollectionSuggestion.selectedItems?.[0]
        ? {
            contentId: videoOrCollectionSuggestion.selectedItems?.[0]?.id,
            contentType:
              videoOrCollectionSuggestion.selectedItems?.[0]?.type ||
              videoOrCollectionSuggestion.selectedItems?.[0]?.contentType,
          }
        : null,
      launchingCountry: launchingCountry,
      relatedFiles: formValues?.relatedFiles || [],
      visibility: formValues?.visibility,
      targetAudiences:
        formValues.targetAudiences?.map(targetAudience => ({
          code: targetAudience,
        })) || [],
    };

    if (!formValues?.expiresIn) {
      delete valuesToUpdate.expiresIn;
    }

    if (!formValues?.publishIn) {
      delete valuesToUpdate.publishIn;
    }

    if (!formValues?.trailerId) {
      delete valuesToUpdate.trailerId;
    }

    if (!formValues?.thumbnails || formValues.thumbnails.length === 0) {
      delete valuesToUpdate.thumbnails;
    }

    if (!videoOrCollectionSuggestion?.selectedItems?.[0]) {
      delete valuesToUpdate.nextSuggestionTimeSeconds;
    }

    if (!formValues?.mediaWithAcessibilityId) {
      delete valuesToUpdate.mediaWithAcessibilityId;
    }

    const filteredObj = Object.fromEntries(
      Object.entries(valuesToUpdate).filter(
        ([_, value]) =>
          value === undefined ||
          value === null ||
          value.length === 0 ||
          value === ''
      )
    );

    //informacoes que não precisam ser validadas ainda
    delete filteredObj['nextContentSuggestion'];
    delete filteredObj['nextSuggestionTimeSeconds'];
    delete filteredObj['keywords'];
    delete filteredObj['personalities'];
    delete filteredObj['mediaWithAcessibilityId'];
    delete filteredObj['trailerId'];
    delete filteredObj['viewsLimit'];
    delete filteredObj['expiresIn'];
    delete filteredObj['allowedCountries'];
    delete filteredObj['deniedCountries'];
    delete filteredObj['comments'];
    delete filteredObj['collections'];
    delete filteredObj['relatedFiles'];

    if (
      valuesToUpdate.title !== undefined &&
      valuesToUpdate.title.length < 3 &&
      valuesToUpdate.title.length > 72
    ) {
      filteredObj['title'] = '';
    }

    if (
      valuesToUpdate.shortDescription !== undefined &&
      valuesToUpdate.shortDescription.length < 3
    ) {
      filteredObj['shortDescription'] = '';
    }

    if (
      valuesToUpdate.fullDescription !== undefined &&
      valuesToUpdate.fullDescription.length < 3
    ) {
      filteredObj['fullDescription'] = '';
    }

    if (valuesToUpdate.launchYear !== undefined) {
      delete filteredObj['launchYear'];
    }

    if (valuesToUpdate.launchYear === null) {
      filteredObj['launchYear'] = '';
    }
    if (
      (valuesToUpdate.thumbnails !== undefined &&
        (valuesToUpdate.thumbnails[0] === undefined ||
          valuesToUpdate.thumbnails[1] === undefined)) ||
      valuesToUpdate.thumbnails === undefined
    ) {
      filteredObj['thumbnails'] = [];
    }

    if (valuesToUpdate.targetAudiences.length === 0) {
      filteredObj['targetAudiences'] = [];
    }

    if (valuesToUpdate.units.length > 0 || valuesToUpdate.channels.length > 0) {
      delete filteredObj['units'];
      delete filteredObj['channels'];
    }

    let keysArray = Object.keys(filteredObj);
    setFormValidation(keysArray);

    await updateVideo(valuesToUpdate);
    if (activeStep === 5) {
      let id = getValues('id') || params.id;
      let version = getValues('version') || params.version;
      let path = `/${id}/versions/${version}`;
      const response = await getVideoById(
        path,
        auth,
        setAuth,
        setIsLoading,
        setNotify
      );
      setVideoResponse(response);
    }

    return keysArray.length > 0 ? false : true;
  };

  const uploadVerification = () => {
    let uploading = false;
    if (
      (videoMainUploadProgress?.percent > 0 &&
        videoMainUploadProgress?.percent < 100) ||
      (trailerUploadProgress?.percent > 0 &&
        trailerUploadProgress?.percent < 100) ||
      (videoAcessibilityUploadProgress?.percent > 0 &&
        videoAcessibilityUploadProgress?.percent < 100) ||
      (legendaTrailerUploadProgress?.percent > 0 &&
        legendaTrailerUploadProgress?.percent < 100) ||
      (legendaAccessibilityUploadProgress?.percent > 0 &&
        legendaAccessibilityUploadProgress?.percent < 100)
    ) {
      uploading = true;
    }

    return uploading;
  };

  return (
    <Container id="video-steps">
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Col
          className="user_col user_col_1_margin_top"
          style={{
            background:
              'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, #E7E7E7, #E7E7E7)',
            marginBottom: 16,
          }}>
          <Box className={isLoading ? 'isLoading' : ''}>
            <Fade
              in={isLoading}
              style={{
                transitionDelay: isLoading ? '800ms' : '0ms',
              }}
              unmountOnExit>
              <CircularProgress />
            </Fade>
          </Box>
          <div className="unit_title_page" style={{ backgroundColor: 'white' }}>
            <div className="unit_title_page1">
              <svg
                width="53"
                height="53"
                viewBox="0 0 53 53"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="4.00391"
                  y="4.4082"
                  width="44"
                  height="44"
                  rx="11"
                  fill="#1361A4"
                  fillOpacity="0.15"
                />
                <g clipPath="url(#clip0_1413_7316)">
                  <path
                    d="M32.6289 19.4707C33.9277 19.4707 35.0039 20.5469 35.0039 21.8457V33.7207C35.0039 35.0566 33.9277 36.0957 32.6289 36.0957H18.3789C17.043 36.0957 16.0039 35.0566 16.0039 33.7207V21.8457C16.0039 20.5469 17.043 19.4707 18.3789 19.4707H32.6289ZM20.1602 34.3145V31.0488H17.7852V33.7207C17.7852 34.0547 18.0449 34.3145 18.3789 34.3145H20.1602ZM20.1602 29.2676V26.2988H17.7852V29.2676H20.1602ZM20.1602 24.5176V21.252H18.3789C18.0449 21.252 17.7852 21.5488 17.7852 21.8457V24.5176H20.1602ZM29.0664 34.3145V28.6738H21.9414V34.3145H29.0664ZM29.0664 26.8926V21.252H21.9414V26.8926H29.0664ZM33.2227 33.7207V31.0488H30.8477V34.3145H32.6289C32.9258 34.3145 33.2227 34.0547 33.2227 33.7207ZM33.2227 29.2676V26.2988H30.8477V29.2676H33.2227ZM33.2227 24.5176V21.8457C33.2227 21.5488 32.9258 21.252 32.6289 21.252H30.8477V24.5176H33.2227Z"
                    fill="#1361A4"
                  />
                </g>
                <rect
                  x="4.00391"
                  y="4.4082"
                  width="44"
                  height="44"
                  rx="11"
                  stroke="#1361A4"
                  strokeOpacity="0.08"
                  strokeWidth="8"
                />
                <defs>
                  <clipPath id="clip0_1413_7316">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(16.0039 16.4082)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span style={{ margin: '0 32px' }}>
                {location?.state?.action === CRUD_STATES.EDIT
                  ? 'Editar'
                  : location?.state?.action === CRUD_STATES.VIEW
                    ? 'Visualizar'
                    : 'Incluir'}{' '}
                vídeo{' '}
              </span>
              <ArrowForwardIosIcon />
            </div>
            {steps.map((step, index) => renderTitle(step, index))}
          </div>
          <div
            className="user_button_page"
            style={{ backgroundColor: 'white' }}>
            <Button
              sx={{
                color: 'rgba(20, 98, 165, 1)',
                backgroundColor: 'transparent',
                '&:hover': {
                  background: 'transparent',
                },
                // boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                textTransform: 'capitalize',
                fontSize: '22px',
                fontWeight: '600',
              }}
              variant="text"
              startIcon={<ArrowBackIosNewOutlined />}
              // onClick={handleClose}
              onClick={handleClose}
              id="video-exit-button">
              Sair
            </Button>
          </div>
        </Col>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Col>
              <MenuSteps
                steps={steps}
                setActiveStep={setActiveStep}
                activeStep={activeStep}
                getValues={getValues}
                getVideoById={getVideoById}
                onSubmit={onSubmit}
                viewFields={viewFields}
              />
            </Col>
          </Grid>
          <Grid item xs={8}>
            {activeStep === 1 && (
              <Col style={{ background: 'transparent', marginBottom: 16 }}>
                <Box
                  className="info-container"
                  style={{ backgroundColor: 'rgba(227, 241, 255, 1)' }}>
                  <Accordion
                    expanded={expanded}
                    onChange={handleAccordionChange(true)}
                    style={{
                      backgroundColor: 'rgba(227, 241, 255, 1)',
                      padding: 14,
                      borderRadius: 12,
                    }}>
                    <AccordionSummary
                      aria-controls="acervod-content"
                      id="acervod-header">
                      <Typography
                        style={{
                          color: 'rgba(52, 64, 84, 1)',
                          fontWeight: 600,
                          fontSize: 14,
                        }}>
                        <svg
                          style={{ marginRight: 7 }}
                          width="39"
                          height="39"
                          viewBox="0 0 39 39"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g opacity="0.3">
                            <rect
                              x="6.50391"
                              y="6.41211"
                              width="26"
                              height="26"
                              rx="5"
                              stroke="#475467"
                              strokeWidth="2"
                            />
                          </g>
                          <g opacity="0.1">
                            <rect
                              x="1.50391"
                              y="1.41211"
                              width="36"
                              height="36"
                              rx="7"
                              stroke="#475467"
                              strokeWidth="2"
                            />
                          </g>
                          <path
                            d="M19.5033 22.7453V19.4119M19.5033 16.0786H19.5116M27.8366 19.4119C27.8366 24.0143 24.1056 27.7453 19.5033 27.7453C14.9009 27.7453 11.1699 24.0143 11.1699 19.4119C11.1699 14.8096 14.9009 11.0786 19.5033 11.0786C24.1056 11.0786 27.8366 14.8096 27.8366 19.4119Z"
                            stroke="#475467"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        Primeiros passos para a publicação de um item no Acervo.
                      </Typography>
                      <Button
                        variant="text"
                        sx={{
                          color: 'rgba(65, 75, 178, 1)',
                          backgroundColor: 'transparent',
                          '&:hover': {
                            background: 'transparent',
                          },
                          textTransform: 'capitalize',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}>
                        {text}
                      </Button>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography id="video-first-steps-info">
                        <div className="info-container-content">
                          <p>
                            Para garantir que este item será cadastrado
                            corretamente no Acervo Sesc SP, por favor, analise
                            os pré-requisitos de publicação e cumprimento dos
                            Padrões e Políticas estabelecidos. Para publicar um
                            item, é importante ter:
                          </p>
                          <ul>
                            <li>
                              Arquivos no padrão de Qualidade Sesc, que podem
                              ser consultados no Manual de Publicação{' '}
                            </li>
                            <li>
                              Arquivos de contratos relativos ao item, para
                              declaração dos Direitos Autorais e definição de
                              permissão de acesso
                            </li>
                            <li>
                              Informações de Obra ou Registro, para
                              preenchimento das Informações Técnicas
                            </li>
                          </ul>
                          <p>
                            Ainda tem dúvidas? Veja nossas{' '}
                            <a
                              href="https://www.sescsp.org.br/politica-de-privacidade/"
                              rel="noreferrer"
                              target="_blank">
                              Políticas de privacidade
                            </a>
                            .
                          </p>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Col>
            )}

            <Col
              style={{
                boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
              }}>
              {activeStep === 1 && (
                <StepOne
                  setIsLoading={setIsLoading}
                  setIsEdit={setIsEdit}
                  reset={reset}
                  getValues={getValues}
                  setValue={setValue}
                  register={register}
                  control={control}
                  watch={watch}
                  errors={errors}
                  activeStep={activeStep}
                  axios={axios}
                  videoProps={videoProps}
                  setVideoProps={setVideoProps}
                  updateVideo={updateVideo}
                  languages={languages}
                  viewFields={viewFields}
                  setVideoFiles={setVideoFiles}
                  videoFiles={videoFiles}
                  subtitleFiles={subtitleFiles}
                  setSubtitleFiles={setSubtitleFiles}
                  legendaIdioma={legendaIdioma}
                  setLegendaIdioma={setLegendaIdioma}
                  setCanAddSubtitle={setCanAddSubtitle}
                  canAddSubtitle={canAddSubtitle}
                  setCanAddAudio={setCanAddAudio}
                  canAddAudio={canAddAudio}
                  setAudioFiles={setAudioFiles}
                  audioFiles={audioFiles}
                  setAudioIdioma={setAudioIdioma}
                  audioIdioma={audioIdioma}
                  idiomaVideo={idiomaVideo}
                  setIdiomaVideo={setIdiomaVideo}
                  typeItem={location?.state?.action}
                />
              )}
              {activeStep === 2 && (
                <StepTwo
                  getValues={getValues}
                  setValue={setValue}
                  reset={reset}
                  register={register}
                  control={control}
                  watch={watch}
                  errors={errors}
                  activeStep={activeStep}
                  axios={axios}
                  videoProps={videoProps}
                  setVideoProps={setVideoProps}
                  updateVideo={updateVideo}
                  setVideoResponse={setVideoResponse}
                  videoResponse={videoResponse}
                  languages={languages}
                  viewFields={viewFields}
                  viewStepTwoFields={false}
                />
              )}
              {activeStep === 3 && (
                <StepThree
                  watch={watch}
                  errors={errors}
                  control={control}
                  setValue={setValue}
                  register={register}
                  wordsList={wordsList}
                  getValues={getValues}
                  viewFields={viewFields}
                  keyWordsList={keyWordsList}
                  setWordsList={setWordsList}
                  selectedOption={selectedOption}
                  setKeyWordsList={setKeyWordsList}
                  setSelectedOption={setSelectedOption}
                  canShowPublishIn={!hasPublishedPreviousVersion}
                />
              )}

              {activeStep === 4 && (
                <StepFour
                  setValue={setValue}
                  control={control}
                  videoResponse={videoResponse}
                  viewFields={viewFields}
                />
              )}

              {activeStep === 5 && (
                <StepFive
                  getValues={getValues}
                  setValue={setValue}
                  register={register}
                  control={control}
                  watch={watch}
                  errors={errors}
                  activeStep={activeStep}
                  axios={axios}
                  videoProps={videoProps}
                  setVideoProps={setVideoProps}
                  authenticatedUser={auth}
                  updateVideo={updateVideo}
                  setComments={setComments}
                  comments={comments}
                  setContracts={setContracts}
                  contracts={contracts}
                  setVideoResponse={setVideoResponse}
                  videoResponse={videoResponse}
                  languages={languages}
                  viewFields={viewFields}
                />
              )}

              {activeStep === 6 && (
                <StepSix
                  getValues={getValues}
                  setValue={setValue}
                  register={register}
                  control={control}
                  watch={watch}
                  errors={errors}
                  activeStep={activeStep}
                  axios={axios}
                  videoProps={videoProps}
                  setVideoProps={setVideoProps}
                  authenticatedUser={auth}
                  updateVideo={updateVideo}
                  videoResponse={videoResponse}
                  setVideoResponse={setVideoResponse}
                  languages={languages}
                  formValidation={formValidation}
                  viewFields={viewFields}
                  userProps={userProps}
                />
              )}
              {activeStep === 7 && (
                <StepSeven
                  getValues={getValues}
                  setValue={setValue}
                  register={register}
                  control={control}
                  watch={watch}
                  errors={errors}
                  activeStep={activeStep}
                  axios={axios}
                  videoProps={videoProps}
                  setVideoProps={setVideoProps}
                  authenticatedUser={auth}
                  updateVideo={updateVideo}
                  videoResponse={videoResponse}
                  setVideoResponse={setVideoResponse}
                  languages={languages}
                  formValidation={formValidation}
                  viewFields={viewFields}
                  userProps={userProps}
                  // setUpdateVideo={setUpdateVideo}
                />
              )}
              <div className="step-button-group mt-3 mb-3 p-3">
                {activeStep > 1 && !viewFields && (
                  <>
                    <Button
                      variant="outlined"
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      onClick={handleBack}
                      disabled={viewFields}
                      id="video-return-step-button">
                      Voltar
                    </Button>
                  </>
                )}

                {activeStep === 7 && (
                  <Button
                    style={{
                      color: 'rgba(52, 64, 84, 1)',
                    }}
                    variant="outlined"
                    onClick={handleOpen}
                    id="video-add-new-video-button">
                    <AddOutlinedIcon
                      style={{ fontSize: 16, color: 'rgb(19, 97, 164)' }}
                    />{' '}
                    Adicionar novo vídeo
                  </Button>
                )}

                <>
                  {!isEdit && !viewFields && (
                    <Button
                      variant="outlined"
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      onClick={handleClose}
                      disabled={viewFields}
                      id="video-cancel-button">
                      Cancelar
                    </Button>
                  )}
                  {!viewFields && (
                    <Button
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      onClick={handleSaveAndExit}
                      variant="outlined"
                      disabled={viewFields || verifyUpload()}
                      id="video-save-and-continue-later-button">
                      Salvar e continuar depois
                    </Button>
                  )}
                </>

                {activeStep !== 6 &&
                  activeStep !== 7 &&
                  activeStep > 1 &&
                  !viewFields && (
                    <>
                      <Button
                        variant="outlined"
                        onClick={handleNextWithoutSave}
                        style={{
                          color: 'rgba(52, 64, 84, 1)',
                        }}
                        id="video-jump-button">
                        Pular
                      </Button>
                    </>
                  )}

                {activeStep !== 7 && (
                  <>
                    <Button
                      style={{
                        color: 'rgba(255, 255, 255, 1)',
                      }}
                      variant="contained"
                      onClick={handleNext}
                      id="video-save-and-advance-button">
                      {!viewFields && 'Salvar e '}Avançar
                    </Button>
                  </>
                )}
                {activeStep === 7 && (
                  <Button
                    style={{
                      color: 'rgba(255, 255, 255, 1)',
                    }}
                    variant="contained"
                    type="submit"
                    onClick={handlePublish}
                    // onClick={handleNext}
                    disabled={viewFields || verifyUpload() || isOverEighteen()}
                    id="video-published-button">
                    Publicar
                  </Button>
                )}

                {activeStep === 7 && viewFields && (
                  <>
                    <Button
                      style={{
                        color: 'rgba(255, 255, 255, 1)',
                        width: 145,
                      }}
                      variant="contained"
                      onClick={handleExit}
                      id="video-ok-button">
                      Ok
                    </Button>
                  </>
                )}
              </div>
            </Col>
          </Grid>
        </Grid>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </form>

      <ModalTitle
        open={openTitleModal}
        createVideo={createVideo}
        onClose={() => setOpenTitleModal(false)}
        CRUD_STATES={CRUD_STATES}
        setAuth={setAuth}
        auth={auth}
        type={'video'}
      />
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
        showCancelWithAction={true}
      />
      <Transcoder
        handleConfirmPublish={handleConfirmPublish}
        setTranscoderAproval={setTranscoderAproval}
        transcoderAproval={transcoderAproval}
      />
    </Container>
  );
}

export default VideosSteps;
